import React from "react";

const WelcomeHeader = ({ user }) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  const getFullName = () => {
    // Check personalDetails.fullName first
    if (user?.personalDetails?.fullName) {
      return user.personalDetails.fullName;
    }
    // Fallback to organizationName
    if (user?.organizationName) {
      return user.organizationName;
    }
    // Last resort - extract from email
    if (user?.email) {
      const namePart = user.email.split("@")[0];
      // Convert email format to readable name (e.g., john.doe -> John Doe)
      return namePart
        .split(/[._-]/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }
    return "there";
  };

  const getCurrentDate = () => {
    return new Date().toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="bg-gradient-to-r from-[#0226BE] to-[#0145E8] rounded-2xl p-6 text-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg
          className="w-full h-full"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <defs>
            <pattern
              id="grid"
              width="10"
              height="10"
              patternUnits="userSpaceOnUse"
            >
              <circle cx="1" cy="1" r="1" fill="white" />
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative z-10 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold mb-1">
            {getGreeting()}, {getFullName()}!
          </h1>
          <p className="text-blue-100 text-sm">{getCurrentDate()}</p>
          <p className="text-blue-200 text-sm mt-2">
            Here's what's happening with your surveys today.
          </p>
        </div>
        <div className="hidden md:flex items-center gap-4">
          <div className="text-right">
            <p className="text-xs text-blue-200 uppercase tracking-wider">
              Organization
            </p>
            <p className="font-medium">{user?.organizationName || "Your Organization"}</p>
          </div>
          <div className="w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;
